




















import {
  Vue,
  Component,
Watch
} from "@/shared/vuepack";
import "@bend-financial/okta-signin-widget/dist/css/okta-sign-in.min.css";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import OktaSignIn from "@bend-financial/okta-signin-widget";
import oktaConfig from "@/okta-config";
import { login as oktaLoginResource } from "@/shared/oktaResources";
import { Config } from "@/shared/config";
import { Home } from "@/admin/route-names";
import { AuthType, LoginMethod } from "../types";
import { OktaAuth } from "@/shared/api/auth";
import {
  LoginParam,
  useUserStore
} from "../store/user";
import { useThemeStore } from "@/shared/store/theme";
import { handleOktaSignInWidgetError } from "@/shared/oktaSignInWidgerErrorHelper";

@Component({
  components: {
    GenericLoadingSpinner
  }
})

export default class AdminPortalOktaLogin extends Vue {
  themeStore = useThemeStore();
  userStore = useUserStore();

  loginParam: LoginParam = { username: "", logoutOnStart: false};
  widget: OktaSignIn = null;

  get imgSrc () {
      return require("../../assets/hsab-logo.png");
  }

  mounted () {
    this.initialize();
  }

  initialize () {
    const oktaSignInConfig = {
        baseUrl: oktaConfig.admin.issuer.split("/oauth2")[0],
        clientId: oktaConfig.admin.clientId,
        redirectUri: oktaConfig.admin.redirectUri,
        logo: this.imgSrc,
        i18n: oktaLoginResource,
        authParams: {
          issuer: oktaConfig.admin.issuer,
          scopes: oktaConfig.admin.scopes,
        },
        features: oktaConfig.features.admin,
        cookies: {
          secure: true
        },
        colors: {
          brand: this.themeStore.primaryColor
        },
        customButtons: []
    };

    this.removeSignInWidget();

    this.widget = new OktaSignIn(oktaSignInConfig);

    this.widget.on("pageRendered", context => {
        const usernameElement: HTMLInputElement = document.getElementById("okta-signin-username") as any;
        const username = usernameElement.value;
        if (username) {
            this.loginParam.username = username;
        }
    });

    this.widget.showSignInToGetTokens({
        el: "#okta-signin-container",
        scopes: oktaConfig.admin.scopes
      }).then(tokens => {
        OktaAuth().setTokens(tokens);
        this.userStore.setAuthType(AuthType.Okta);
        this.userStore.login(this.loginParam);
      })
      .catch(error => alert(error))
      .finally(() => {
        this.removeSignInWidget();
      });

    this.widget.on("afterError", (context, error) => handleOktaSignInWidgetError({ context, error }));
  }

  @Watch("userStore.loggedIn")
  onLoggedIn (newValue) {
    if (newValue === true) {
        this.$router.push(Home);
    }
  }

  removeSignInWidget () {
    if (this.widget) {
      this.widget.off();
      this.widget.remove();
    }
  }

  destroyed () {
    // Remove the widget from the DOM on path change
    this.removeSignInWidget();
  }
}
